import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Input, OnChanges, OnInit, SimpleChanges, booleanAttribute } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { InputSelectComponent } from 'src/app/shared/components/inputs/input-select/input-select.component';
import { IstatComuniService } from '../../istat-comuni.service';
import { IstatComuniSearchTemplateComponent } from '../istat-comuni-search-template/istat-comuni-search-template.component';
import { IFilters } from 'src/app/core/models/filters.model';

@Component({
  selector: 'app-istat-comuni-input-select',
  standalone: true,
  imports: [
    CommonModule,
    InputSelectComponent,
    IstatComuniSearchTemplateComponent
  ],
  templateUrl: './istat-comuni-input-select.component.html',
  styleUrl: './istat-comuni-input-select.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IstatComuniInputSelectComponent implements OnInit, OnChanges {
  @Input() form!: FormGroup;
  @Input() name: string = '';
  @Input() filter: string = '';
  @Input({ transform: booleanAttribute }) preload: boolean = true;

  comuni = this.comuniService.query.list;
  searchTemplate = IstatComuniSearchTemplateComponent;

  constructor(
    @Inject(IstatComuniService) public comuniService: IstatComuniService,
  ) { }

  ngOnInit(): void {
    if (this.preload === true) {
      this.getComuni(this.filter);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('filter') && !changes['filter'].isFirstChange()) {
      this.getComuni(changes['filter'].currentValue);
    }
  }

  getComuni(filter?: string) {
    let filters: IFilters | undefined = undefined;
    if (filter && filter !== null && filter !== '') {
      filters = this.getFilters(filter);
    }
    this.comuniService.query.getAll(filters);
  }

  private getFilters(filter: string) {
    const filters: IFilters = {};
    const [key, value] = filter.split('=');
    if (value && value !== undefined && value !== 'undefined' && value !== null && value !== 'null') {
      filters[key] = value;
      return filters;
    } else {
      return undefined;
    }
  }
}
